import React from "react";
import { GetApp } from "@mui/icons-material";
import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import useGetPdf from "../../helpers/hooks/useGetPdf";
import Loading from "./Loading";

export default function ExportPDFButton({ fileInfo, fileType}){
    const {isPending, handleClick} = useGetPdf(fileInfo, fileType);
    console.log(fileInfo.toString())
    return(
        <Button 
            variant="contained" 
            size="large" 
            sx={{ marginRight: 1.5, backgroundColor: "#4CAF50", color: "#fff"}} 
            onClick={() => handleClick()}>
            {isPending ? "Downloading..." : "Download"}
        </Button>
    )
}   